import React from 'react';
import LeftLoginSection from './left-login-section';
import RightLoginSection from './right-login-section';

const Login = () => {
  return (
    <div className='flex flex-col-reverse md:flex-row md:h-[100vh]'>
      <LeftLoginSection />
      <RightLoginSection />
    </div>
  );
};

export default Login;
